import { render, staticRenderFns } from "./FileManagerEditTemplateComponent.vue?vue&type=template&id=67ba47b6&scoped=true&lang=pug"
import script from "./FileManagerEditTemplateComponent.vue?vue&type=script&lang=ts"
export * from "./FileManagerEditTemplateComponent.vue?vue&type=script&lang=ts"
import style0 from "./FileManagerEditTemplateComponent.vue?vue&type=style&index=0&id=67ba47b6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ba47b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67ba47b6')) {
      api.createRecord('67ba47b6', component.options)
    } else {
      api.reload('67ba47b6', component.options)
    }
    module.hot.accept("./FileManagerEditTemplateComponent.vue?vue&type=template&id=67ba47b6&scoped=true&lang=pug", function () {
      api.rerender('67ba47b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FileManager/FileManagerEditTemplateComponent.vue"
export default component.exports